module.exports = __webpack_public_path__ + "img/iconKongZhiCheLiangDaoZha.81db0289.svg";